import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear, faCartShopping, faHome, faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
const logo = require('../assets/images/esl-logo.png')

interface NavbarProps {
  setNavigation: React.Dispatch<React.SetStateAction<string>>
  navigation: string
  account: Account
  mappingBoardsLength: number | null
}

export const Navbar: React.FC<NavbarProps> = ({ setNavigation, navigation, account, mappingBoardsLength }) => {
  // const openUserManual = () => {
  //   window.open('https://www.eswlab.com/products/freshworks/esls-freshworks-for-monday-installation-user-guide/freshservice-monday/', "Modal", "modal=yes,width=800,height=800")
  // }

  return (
    <header className="navbar-container">
      <div className="navbar-left">
        <nav>
          <span title="Home" className={navigation === 'Home' ? 'active nav-btn' : 'nav-btn'}>
            <FontAwesomeIcon icon={faHome} onClick={() => setNavigation('Home')} />
          </span>
          <span title="Purchase" className={navigation === 'Purchase' ? 'active nav-btn' : 'nav-btn'}>
            <FontAwesomeIcon icon={faCartShopping} onClick={() => setNavigation('Purchase')} />
          </span>
          <span title="Settings" className={navigation === 'Settings' ? 'active nav-btn' : 'nav-btn'}>
            <FontAwesomeIcon icon={faGear} onClick={() => setNavigation('Settings')} />
          </span>
          <span title="User Manual" className={navigation === 'Help' ? 'active nav-btn' : 'nav-btn'}>
            <FontAwesomeIcon icon={faCircleQuestion} onClick={() => setNavigation('Help')} />
          </span>
        </nav>
        <div className="license-info">
          <p>{account.ticketsSentMonthly} Tickets sent this month</p> | 
          <p>License: <span>{account.license}</span> </p>
        </div>
      </div>
      <div className="navbar-right">
        <img src={logo} alt="logo" />
      </div>
    </header>
  )
}
